import React from 'react';
import * as Styled from './styled';
import ThemeSwitch from '@containers/header/theme-switch';

const Header = () => {
    return (
        <Styled.HeaderWrapper>
            <Styled.HeaderText>
                scarves.mamikonyan.io
            </Styled.HeaderText>
            <ThemeSwitch />
        </Styled.HeaderWrapper>
    );
};

export default Header;
